import React from 'react';
import styled from '@emotion/styled';
import { Flex, Text } from '@qga/roo-ui/components';

import { HeroPricing } from '@/v2/services/sanity/types/api/response/homepageHero';

const Wrapper = styled(Flex)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

const Pricing = ({
  price,
  priceOverline,
  priceSubtext,
  priceSuffix,
}: HeroPricing) => {
  return (
    <Wrapper>
      {priceOverline && <Text fontSize="sm">{priceOverline}</Text>}
      <Flex alignItems="center" my={2}>
        <Text fontWeight={600} fontSize="36px" lineHeight={0}>
          ${price}
        </Text>
        {priceSuffix && (
          <Text ml={1} fontSize="sm">
            {priceSuffix}
          </Text>
        )}
      </Flex>
      {priceSubtext && <Text fontSize="sm">{priceSubtext}</Text>}
    </Wrapper>
  );
};

export default Pricing;
